<template>
  <div class="link-iframe-wrapper">
    <iframe class="link-iframe" :src="src"></iframe>
  </div>
</template>

<script>
export default {
  name: "linkIframe",
  data() {
    return {
      src: ""
    }
  },
  methods: {
    initIframeSrc() {
      this.src = this.$route.query.linkSrc
    }
  },
  created() {
    this.initIframeSrc()
  }
}
</script>

<style lang="scss" scoped>
.link-iframe-wrapper {
  height: 100%;
  width: 100%;
  background: #ffffff;
  overflow: auto;
  .link-iframe {
    width: 100%;
    min-height: 100%;
    border: none;
    background: #ffffff;
    margin: 0;
    padding: 0;
  }
}
</style>
